// extracted by mini-css-extract-plugin
module.exports = {"logo":"ShopBar_logo__2SGNo","container":"ShopBar_container__3vrGA","controlsContainer":"ShopBar_controlsContainer__35yzf","buy":"ShopBar_buy__37Giw"};